var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-accordion"},[_c('div',{staticClass:"o-typography--action c-accordion__header",on:{"click":_vm.toggle}},[_vm._t("header")],2),_c('v-collapse',{staticClass:"c-accordion__content",attrs:{"expanded":_vm.isExpanded}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }